module.exports = __webpack_public_path__ + "public/media/developer-right.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-right.png
// module id = ./images/services/developer-right.png
// module chunks = 0